// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__g_xgd","emails":"CreateEditClinics_emails__2YvYN","emailTagLabel":"CreateEditClinics_emailTagLabel__1JF3g"};